import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayServices } from '../../../takeaway/services';
import { OrdersSelectPage } from '../../../orders/orders-select/orders-select';
import { PrintServices } from '../../../services/printServices';
import { TakeawayOrderSelectPage } from '../../../takeaway/takeaway-order-select/takeaway-order-select';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { NotificationsServices } from '../../../services/notificationsServices';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pos-list-elements',
  templateUrl: 'pos-list-elements.html',
})
export class PosListElementsPage {

  @Input() platform: string;
  @Input() list_elements: any;
  @Input() origin: string;
  @Input() type: string;
  @Input() list_elements_part: any;
  @Input() update: boolean;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public takeawayServices: TakeawayServices,
    public printServices: PrintServices,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public analyticsServices: AnalyticsServices,
    private notificationsServices: NotificationsServices) {

  }


  deleteTableSwitch(valueSearch, index) {
    if (this.origin == 'order') {//order
      this.deleteTableListOrders(valueSearch, index);
    } else if (this.origin == 'tk') {//takeaway
      this.deleteTableListTK(valueSearch, index);
    }
  }

  deleteTableSwitchCombo(uid_combo_tmp, index) {
    if (this.origin == 'order') {//order
      this.deleteTableListOrdersCombo(uid_combo_tmp, index);
    } else if (this.origin == 'tk') {//takeaway
      this.deleteTableListTKCombo(uid_combo_tmp, index);
    }
  }

  //Elimina un elemento de una mesa
  deleteTableListOrders(valueSearch, index) {
    //delete element
    var position_element = Object.keys(this.ordersCoServices.order_tmp[index].list).find(k => this.ordersCoServices.order_tmp[index].list[k].name === valueSearch);
    delete this.ordersCoServices.order_tmp[index].list[Number(position_element)];

    //if section empty delete section
    if (Object.keys(this.ordersCoServices.order_tmp[index].list).length == 0) {
      this.ordersCoServices.order_tmp.splice(index, 1);
    }

    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'remove',
      'value': 1,
      'source': 'orders',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
  }


  deleteTableListTK(valueSearch, index) {
    //delete element
    var position_element = Object.keys(this.takeawayServices.order_tmp[index].list).find(k => this.takeawayServices.order_tmp[index].list[k].name === valueSearch);
    delete this.takeawayServices.order_tmp[index].list[Number(position_element)];
    //if section empty delete section
    if (Object.keys(this.takeawayServices.order_tmp[index].list).length == 0) {
      this.takeawayServices.order_tmp.splice(index, 1);
    }
    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'remove',
      'value': 1,
      'source': 'takeaway',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
  }

  //Elimina un combo de una mesa
  deleteTableListOrdersCombo(uid_combo_tmp, index) {
    //delete element
    var position_element = Object.keys(this.ordersCoServices.order_tmp[index].list).find(k => this.ordersCoServices.order_tmp[index].list[k].uid_combo_tmp === uid_combo_tmp);
    delete this.ordersCoServices.order_tmp[index].list[Number(position_element)];
    //delete elements of combo
    for (var index_order in this.ordersCoServices.order_tmp) {
      if (this.ordersCoServices.order_tmp[index_order].name !== 'Menu') {
        for (var index_element in this.ordersCoServices.order_tmp[index_order].list) {
          if (this.ordersCoServices.order_tmp[index_order].list[index_element].uid_combo_tmp === uid_combo_tmp) {
            delete this.ordersCoServices.order_tmp[index_order].list[index_element];
          }
        }
      }
    }
    //if section empty delete section
    if (Object.keys(this.ordersCoServices.order_tmp[index].list).length == 0) {
      this.ordersCoServices.order_tmp.splice(index, 1);
    }

    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'remove',
      'value': 1,
      'source': 'orders',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
  }

  //Elimina un combo de un takeaway
  deleteTableListTKCombo(uid_combo_tmp, index) {
    //delete combo
    var position_element = Object.keys(this.takeawayServices.order_tmp[index].list).find(k => this.takeawayServices.order_tmp[index].list[k].uid_combo_tmp === uid_combo_tmp);
    delete this.takeawayServices.order_tmp[index].list[Number(position_element)];
    //delete elements of combo
    for (var index_order in this.takeawayServices.order_tmp) {
      if (this.takeawayServices.order_tmp[index_order].name !== 'Menu') {
        for (var index_element in this.takeawayServices.order_tmp[index_order].list) {
          if (this.takeawayServices.order_tmp[index_order].list[index_element].uid_combo_tmp === uid_combo_tmp) {
            delete this.takeawayServices.order_tmp[index_order].list[index_element];
          }
        }
      }
    }
    //if section empty delete section
    if (Object.keys(this.takeawayServices.order_tmp[index].list).length == 0) {
      this.takeawayServices.order_tmp.splice(index, 1);
    }
    //data set waiter activity
    var extra_activity: any =
    {
      'type': 'remove',
      'value': 1,
      'source': 'takeaway',

    };
    this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
  }

  /*ORDERS FUNCTIONS*/
  printSectionOrder(order, section) {

    //caso order
    this.globals.GAtrackView('Orders', 'Orders - Order - Print', this.globals.restaurant.email, 'View', 'Print order', 'Orders', '');
    if (this.globals.restaurant.printer_type == 'native') {
      this.globals.print_content = document.getElementById('print_order');

      this.ordersCoServices.orders_print = 'change';
      this.ordersCoServices.print_order_part = section;
      this.ordersCoServices.print_order = order;
      this.ordersCoServices.kitchen_filter = 'pos-list';
      //interval para imprimir correctamente
      var interval = setInterval(() => {
        this.printServices.printNow('print_order');
        clearInterval(interval);
      }, 1000);
    } else {
      this.printServices.prepareOrderKitchen('indv', section, order, this.globals.restaurant.printer_type, 'pos-list');
    }

  }

  openSelect() {
    this.ordersCoServices.update_state = false;
    this.navCtrl.push(OrdersSelectPage);
  }

  async onGoingKitchen(order, index) {
    if (this.globals.checkLimitsByLicense('tpv', 'marchar_cocina')) {
      //set ongoing true
      order.sections[index].ongoing = true;

      //update firestore
      this.ordersCoServices.afs.collection('orders').doc(order.UID).update({
        sections: order.sections,
        updated_at: new Date(),
      }).then(doc => {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-marchando-cocina'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });
      //Enviamos la notificacion a cocina
      this.orderGoing(order);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openModElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-modificar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.openModSelect(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openDelElement(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-elminar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteElement(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }

  openModSelect(i, j, element) {
    if (element.sections[i].list[j].uid_combo_tmp != undefined) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-editar-combo'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {

      this.ordersCoServices.i = i;
      this.ordersCoServices.j = j;
      this.ordersCoServices.element = element;
      this.ordersCoServices.update_state = true;
      this.navCtrl.push(OrdersSelectPage);
    }
  }

  deleteElement(i, j, element) {
    //delete combo primary element
    element.sections[i].list[j].state = 'delete';
    element.sections[i].list[j].finish = '';
    //delete combo selecctionable elements
    for (let _section of element.sections) {
      for (let _element of _section.list) {
        if ((element.sections[i].list[j].uid_combo_tmp != undefined && _element.uid_combo_tmp != undefined) && element.sections[i].list[j].uid_combo_tmp == _element.uid_combo_tmp) {
          _element.state = 'delete';
          //deleteFromTPV
          if (_element.change != '') {
            this.deleteFromTPV(_element.change, _element);
          } else {
            this.deleteFromTPV(_element.name, _element);
          }
        }
      }
      //insert _data analytics WAITER
      let _element = [];
      _element.push(element.sections[i].list[j].name)
      var waiter = {
        'uid': this.globals.restaurant_uid,
        'waiter': this.globals.waiter,
        'elements': _element,
        'date': new Date(),
        'type': "waiter",
        'type_type': "DELETE",
      };
      this.analyticsServices.sendWaiter(waiter);
    }
    //update
    this.ordersCoServices.afs.collection('orders').doc(element.UID).update({
      sections: element.sections,
    }).then(async doc => {
      if (element.sections[i].list[j].change != '') {
        this.deleteFromTPV(element.sections[i].list[j].change, element.sections[i].list[j]);
      } else {
        this.deleteFromTPV(element.sections[i].list[j].name, element.sections[i].list[j]);
      }
    });
  }

  one_time: boolean = true;
  deleteFromTPV(name, element) {
    this.one_time = true;
    this.ordersCoServices.table_tmp = this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index];

    for (let list of this.globals.objectToArray(this.ordersCoServices.table_tmp.ticket.list)) {
      //Comprueba que el nombre del elemento sea el mismo que el eliminado
      if (list.name == name && this.one_time && list.delete == false && list.count == true && list.uid_combo_tmp == element.uid_combo_tmp) {
        //Comprobamos que el count de variaciones sea el mismo
        if (this.globals.objectToArray(list.variation).length == this.globals.objectToArray(element.variations).length) {
          //Si las variaciones son 0, eliminamos el elemento, si no recorremos las variaciones
          if (this.globals.objectToArray(element.variations).length == 0) {
            list.count = false;
            list.delete = true;
            this.one_time = false;
          } else {
            //Comprueba que las variaciones sean las mismas
            var _delete = true;
            for (let variation of this.globals.objectToArray(list.variation)) {
              let index = element.variations.findIndex(_variation => (_variation.name == variation.name && _variation.state == variation.state));
              if (index == -1) {
                _delete = false;
              }
            }
            //Si _delete es true, podemos eliminar el elemento, ya que ha coincidido todo
            if (_delete) {
              list.count = false;
              list.delete = true;
              this.one_time = false;
            }
          }
        }
      }
    }

    this.ordersCoServices.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
      ticket: {
        amount: this.ordersCoServices.table_tmp.ticket.amount,
        payment: this.ordersCoServices.table_tmp.ticket.payment,
        payment_type: this.ordersCoServices.table_tmp.ticket.payment_type,
        date: this.ordersCoServices.table_tmp.ticket.date,
        number: this.ordersCoServices.table_tmp.ticket.number,
        waiter: this.ordersCoServices.table_tmp.ticket.waiter,
        waiter_uid: this.ordersCoServices.table_tmp.ticket.waiter_uid,
        list: this.ordersCoServices.table_tmp.ticket.list,
        updated_at: new Date(),
        created_at: this.ordersCoServices.table_tmp.ticket.created_at,
        tip: this.ordersCoServices.table_tmp.ticket.tip || 0,
      },
      state: 'close',
    }).then(async doc => {
      //data set waiter activity
      var extra_activity: any =
      {
        'type': 'cancel',
        'value': 1,
        'source': 'orders',

      };
      this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
      this.navCtrl.pop();
    });


  }


  /*ORDERS POSITION*/
  async onChange(val, i, j, element) {
    //loadingPopup
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //caso combo tirar toast que no se puede
    if (element.sections[j].list[i].uid_combo_tmp != undefined || element.sections[j].list[i].uid_combo_tmp == '') {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-cambia-posicion-combo'),
        duration: 3000,
        position: 'top'
      });
      //lanzar toast + loading dismiss
      toast.present();
      loadingPopup.dismiss();
    } else {//caso no combo se puede cambiar de posición
      //insert in new section 
      for (let _sect of element.sections) {
        if (_sect.name == val) {
          _sect.list.push(element.sections[j].list[i]);
        }
      }
      //eliminate of old sectio
      element.sections[j].list.splice(i, 1);
      //update canvis sections
      await this.ordersCoServices.afs.collection('orders').doc(element.UID).update({
        sections: element.sections,
      }).then(doc => {
        loadingPopup.dismiss();
      });
    }


  }

  back() {
    this.navCtrl.pop();
  }

  /*TAKEAWAY*/

  openModElementTK(i, j, element) {
    if (element.sections[i].list[j].uid_combo_tmp != undefined) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-editar-combo'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      this.takeawayServices.i = i;
      this.takeawayServices.j = j;
      this.takeawayServices.element = element;
      this.takeawayServices.update_state = true;
      this.navCtrl.push(TakeawayOrderSelectPage);
    }
  }

  openDelElementTK(i, j, element) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-seleccionar-plato-producto'),
      message: this.translate.instant('instant-elminar-plato-producto-seleccionado'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteElementTK(i, j, element);
          }
        }
      ]
    });
    confirm.present();
  }


  deleteElementTK(i, j, element) {

    //delete combo primary element
    element.sections[i].list[j].state = 'delete';
    element.sections[i].list[j].finish = '';
    //delete combo selecctionable elements
    for (let _section of element.sections) {
      for (let _element of _section.list) {
        if ((element.sections[i].list[j].uid_combo_tmp != undefined && _element.uid_combo_tmp != undefined) && element.sections[i].list[j].uid_combo_tmp == _element.uid_combo_tmp) {
          _element.state = 'delete';
          //deleteFromTPV
          if (_element.change != '') {
            this.deleteTableTK(_element.change, _element);
          } else {
            this.deleteTableTK(_element.name, _element);
          }
        }
      }
    }
    //update
    this.ordersCoServices.afs.collection('orders').doc(element.UID).update({
      sections: element.sections,
    }).then(async doc => {
      if (element.sections[i].list[j].change != '') {
        this.deleteTableTK(element.sections[i].list[j].change, element.sections[i].list[j]);
      } else {
        this.deleteTableTK(element.sections[i].list[j].name, element.sections[i].list[j]);
      }
    });
    //insert _data analytics WAITER
    let _element = [];
    _element.push(element.sections[i].list[j].name)
    var waiter = {
      'uid': this.globals.restaurant_uid,
      'waiter': this.globals.waiter,
      'elements': _element,
      'date': new Date(),
      'type': "waiter",
      'type_type': "DELETE",
    };
    this.analyticsServices.sendWaiter(waiter);
  }

  async deleteTableTK(name, element) {
    this.one_time = true;
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //recuperar mesa
    this.takeawayServices.table_tmp = this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index];

    for (let list of this.globals.objectToArray(this.takeawayServices.table_tmp.ticket.list)) {
      if (list.name == name && this.one_time && list.delete == false && list.count == true && list.uid_combo_tmp == element.uid_combo_tmp) {
        list.count = false;
        list.delete = true;
        this.one_time = false;
      }
    }
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    //
    this.takeawayServices.afs.collection('tables').doc(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].UID).update({
      ticket: {
        amount: this.takeawayServices.table_tmp.ticket.amount,
        payment: this.takeawayServices.table_tmp.ticket.payment,
        payment_type: this.takeawayServices.table_tmp.ticket.payment_type,
        date: this.takeawayServices.table_tmp.ticket.date,
        number: this.takeawayServices.table_tmp.ticket.number,
        waiter: this.takeawayServices.table_tmp.ticket.waiter,
        waiter_uid: this.takeawayServices.table_tmp.ticket.waiter_uid,
        list: this.takeawayServices.table_tmp.ticket.list,
        updated_at: new Date(),
        created_at: this.takeawayServices.table_tmp.ticket.created_at,
        delivery: this.takeawayServices.table_tmp.ticket.delivery,
        order_state: this.globals.ifVarEmpty(this.takeawayServices.table_tmp.ticket.order_state),
        tip: this.takeawayServices.table_tmp.ticket.tip || 0,
      },
      state: 'close'
    }).then(async doc => {
      //data set waiter activity
      var extra_activity: any =
      {
        'type': 'cancel',
        'value': 1,
        'source': 'takeaway',

      };
      this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
      //getIndexByTableuid
      this.takeawayServices.getIndexByTableuid();
      //
      this.takeawayServices.selected_list = this.takeawayServices.listSelectedTicket('name', this.globals.objectToArray(this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index].ticket.list))
      this.navCtrl.pop();
    });


  }
  //caso especial que el combo tenga las secciones 
  //con el mismo nombre que algun menu
  checkElementsNoComboInCombo(value) {
    var _return = false;
    if (value.only_combo) {
      for (let element of this.globals.objectToArray(value.list)) {
        if (element.uid_combo_tmp == undefined) {
          _return = true;
        }
      }
      return _return;
    } else {
      return false;
    }
  }

  async orderGoing(order) {
    let _notification = {};

    //por tipo
    if (order.type == "table") {//si es una mesa
      _notification = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant("notification-push-pedido-marcha-title"),
        'description': this.translate.instant("notification-push-pedido-marcha-desc") + order.table,
      }
    } else if (order.provider_code != "") {//si es de ordatic
      _notification = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant("notification-push-pedido-marcha-title"),
        'description': this.translate.instant("notification-push-pedido-marcha-desc") + order.provider_code,
      }
    } else {
      _notification = {//si no tiene ningun cliente asignado
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant("notification-push-pedido-marcha-title"),
        'description': this.translate.instant("notification-push-pedido-marcha-desc") + order.delivery,
      }
    }

    this.notificationsServices.notificationPushByRol(_notification, "kitchen");
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-list-elements/pos-list-elements.ts